import JenisBarangJadi from "./JenisBarangJadi";

export default JenisBarangJadi